/* eslint-disable react-hooks/exhaustive-deps */
import {useState} from "react"
import {FilterKey} from "types/filter"
import {Tabs} from "antd"
import {TabHeader} from "components/Tab"
import {CallLog} from "./CallLog"
import {VoiceMail} from "./VoiceMail"
import {useQuery} from "@tanstack/react-query"
import {studentCallLogService} from "services"
import {getUnreadCountBadge, handleError} from "helpers"
import styles from "./StudentCallLog.module.css"
import {useActiveTab} from "hooks"

type Props = {
    departmentId: number
    studentProfileId?: number
}

const {TabPane} = Tabs

enum Tab {
    CallLog = "call-log",
    VoiceMail = "voice-mail"
}

export function StudentCallLog(props: Props) {
    const [activeTabKey, onChangeTab] = useActiveTab(Tab.CallLog, "subtab")
    const {studentProfileId, departmentId} = props

    const {data: voiceMailUnreadCount} = useQuery(
        ["voicemail-unread-count", departmentId],
        () => studentCallLogService.getVoiceMailUnreadCount(departmentId),
        {
            initialData: {unreadCount: 0},
            onError: (err) => {
                handleError(err)
            }
        }
    )

    return (
        <div>
            <Tabs className="fullwidth klassSubTab" activeKey={activeTabKey} onChange={onChangeTab}>
                <TabPane tab={<TabHeader title="Call Log" />} key={Tab.CallLog}>
                    {activeTabKey === Tab.CallLog && (
                        <CallLog
                            departmentId={departmentId}
                            filterKey={
                                studentProfileId ? FilterKey.AdmissionStudentCallLog : FilterKey.AdmissionCallLog
                            }
                            studentProfileId={studentProfileId}
                        />
                    )}
                </TabPane>
                <TabPane
                    tab={
                        <TabHeader
                            title="Voice Mail"
                            indicator={
                                voiceMailUnreadCount?.unreadCount > 0 ? (
                                    <span className={styles.unreadCount}>
                                        {getUnreadCountBadge(voiceMailUnreadCount.unreadCount)}
                                    </span>
                                ) : undefined
                            }
                        />
                    }
                    key={Tab.VoiceMail}>
                    {activeTabKey === Tab.VoiceMail && (
                        <VoiceMail
                            departmentId={departmentId}
                            filterKey={
                                studentProfileId ? FilterKey.AdmissionStudentVoiceMail : FilterKey.AdmissionVoiceMail
                            }
                            studentProfileId={studentProfileId}
                        />
                    )}
                </TabPane>
            </Tabs>
        </div>
    )
}
